export default function buildAdParams({
  content,
  videoData,
  resumePosition,
  userId,
  rnd,
  vcid = '',
  prof = 'stv_web',
  csid = 'STV_PlayerWeb_VOD',
  pvrn,
  vprn,
}) {
  // eslint-disable-next-line no-param-reassign
  if (!rnd) rnd = (Math.floor(Math.random() * 10000000000000000))
  const {
    contentIsChapter, isPlayerPlus, type, playerApiRefId,
  } = videoData

  const contentTypes = {
    episode: 'long_form',
    shortform: 'short_form',
    chapter: 'long_form',
  }

  const caid = playerApiRefId || videoData?.guid

  const cuepoints = content._cuePoints

  const bp = cuepoints && cuepoints
    // filter out cues before start position
    .filter(point => point > resumePosition)
    .map(c => Math.floor(c / 1000))
    .join(',')

  // Needs to be double-encoded to get passed through Brightcove's system for some reason
  const ci = encodeURIComponent(encodeURIComponent(content.programme.name))
  const caidValue = caid || ci
  const contentType = contentIsChapter ? 'chapter' : type
  const env = (window?.parent?.STV?.environment === 'production') || 'production'
  const shares = env === 'production'
    ? `aws-dev-${content._videoplazaId}`
    : content._videoplazaId

  // skip prerolls if we're resuming
  const flags = (contentType === 'chapter' || resumePosition) && 'noprerolls'

  const tags = [
    // replace spaces in tags with _
    ...content.video.tags.replace(/ /gi, '_').split(','),
    isPlayerPlus && 'svod',
    flags,
    contentTypes[contentType],
    'brightcove', // required for Invidi to target SSAI traffic correctly
  ].filter(Boolean).join(',')

  const paramsObject = {
    bp, // break points for midrolls
    cf: contentTypes[contentType], // content form
    ci, // content identifier
    ...(flags && {
      f: flags,
    }),
    pid: userId,
    rnd,
    s: shares,
    t: tags,
    vht: 1080, // video height
    vwt: 1920, // video width
    _fw_player_width: 1920,
    _fw_player_height: 1080,
    vcid,
    vcid2: userId ?? `unregistered_${vcid}`, // cognito id
    prof, // stv_web
    caid: caidValue,
    csid,
    pvrn,
    vprn,
  }

  const paramsString = Object.keys(paramsObject)
    .map(key => (paramsObject[key] || paramsObject[key] === '') && `${key}=${paramsObject[key]}`)
    .filter(Boolean)
    .join('&')

  return paramsString
}
